<template>
  <div class="animated fadeIn gofixTab contractEquipmentTab assetManagement bgV2">
        <div class="boxShadow h-100 setBorderRadius">
            <b-row class="h-100">
                <b-col md="3" class="h-100">
                  <split-pane :min-percent="100" :default-percent="100" split="horizontal" >
                      <template slot="paneL">
                            <gofix-card title="Tables" class="contractTree">
                                <div class="contenAbsolute">
                                    <div class="tree-view-properties">
                                      <tree ref="treeViewModules" @node:selected="changeTableName" :data="treeData" class="tree-view-properties"></tree>
                                    </div>
                                </div>    
                            </gofix-card>
                      </template>
                  </split-pane>
                </b-col>
                <b-col md="9" class="h-100 pl-0">
                    <gofix-card class="cardTable" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :column-width-setting="columnWidthSetting"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                            <template slot="gofix_table:after-control-left" slot-scope="data">
                                <gofix-button :disabled="tableItems.length == 0 || (!$checkRole($accessModule.table_purging, 'delete'))" class="ml-2" label="Delete All Entries" @click="modalDel.open = true" outline></gofix-button>
                            </template>
                            <template :slot="`gofix_table:${item.key}`" slot-scope="row" v-if="item.key != 'actions'" v-for="(item, index) in fields">
                                <template v-if="item.type == 'date'">
                                    {{ row.item[item.key] | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                                </template>
                                <template v-else-if="['timestamp without time zone', 'timestamp with time zone'].includes(item.type)">
                                    {{ row.item[item.key] | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="['time without time zone', 'time with time zone'].includes(item.type)">
                                    {{ row.item[item.key] | formatDatebyMoment("HH:mm:ss","HH:mm:ss") }}
                                </template>
                                <template v-else>
                                    {{ row.item[item.key] }}
                                </template>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modalDel.open">
                <div class="center">Are you sure you want to<br/>delete <strong>All entries</strong>?</div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="modalDel.open = false">No</b-button>
                    <b-button class="custom-btn" @click="deleteAll" :disabled="modalDel.loading">
                        <b-spinner v-if="modalDel.loading" small type="grow"></b-spinner>Yes
                    </b-button>
                </b-button-group>
            </b-modal>
        </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LiquorTree from 'liquor-tree';

const tablePurging = [
    { 
        text: 'Client Contracts', 
        data: { table_name: 'contracts' },
        children: [
            { 
                text: 'Service Category',
                data: { table_name: 'service_categories' },
                children: [
                    { 
                        text: 'Fault Type',
                        data: { table_name: 'fault_types' },
                    },
                ],
            },
            { 
                text: 'SLA',
                data: { table_name: 'sla' },
                children: [
                    { 
                        text: 'Priority Matrix',
                        data: { table_name: 'sla_fault_types' },
                    },
                ],
            },
            { 
                text: 'Property',
                data: { table_name: 'properties' },
                children: [
                    { 
                        text: 'Inventory',
                        data: { table_name: 'room_inventory_sets' },
                    },
                ],
            },
            { 
                text: 'Equipment',
                data: { table_name: 'equipment' }
            },
            { 
                text: 'Equipment Group',
                data: { table_name: 'equipment_groups' }
            },
            { 
                text: 'SOR',
                data: { table_name: 'sor_items' }
            },
            { 
                text: 'SOR Group',
                data: { table_name: 'sor_groups' }
            },
            { 
                text: 'Maintenance Program',
                data: { table_name: 'sor_items' },
                children: [
                    { 
                        text: 'Maint. Schedule',
                        data: { table_name: 'maintenance_schedule' },
                    },
                ],
            },
            { 
                text: 'Checklist Temp',
                data: { table_name: 'checklist_templates' }
            },
            { 
                text: 'Approval',
                data: { table_name: 'approval_templates' }
            },
            { 
                text: 'Finance',
                data: { table_name: null },
                children: [
                    { 
                        text: 'Head Lease',
                        data: { table_name: 'head_leases' },
                    },
                    { 
                        text: 'Department Code & Debtor Code',
                        data: { table_name: 'finance_linkings' },
                    },
                    { 
                        text: 'FM Codes',
                        data: { table_name: 'fm_codes' },
                    },
                ],
            }
        ]  
    },
    { 
        text: 'Supplier Contracts', 
        data: { table_name: 'contracts' },
    },
    { 
        text: 'Case Management', 
        data: { table_name: 'cases' },
    },
    { 
        text: 'Work Orders', 
        data: { table_name: 'orders' },
    },
    { 
        text: 'Preventive Maintenance', 
        data: { table_name: null },
        state: { expanded: true },
        children: [
            { 
                text: 'Parts Replacement Records', 
                data: { table_name: 'parts_replacement_history_items' }
            },
            { 
                text: 'Job List', 
                data: { table_name: 'joblist' },
                state: { selected: true } 
            },
            { 
                text: 'Issue Register', 
                data: { table_name: 'issue_register' }
            },
        ],
    },
    { 
        text: 'Finance', 
        data: { table_name: null },
        children: [
            { 
                text: 'General Ledger', 
                data: { table_name: 'journal_log_details' }
            },
            { 
                text: 'Posting Rules', 
                data: { table_name: 'posting_rules' },
            },
            { 
                text: 'GL Account Names', 
                data: { table_name: 'gl_account_names' },
            },
            { 
                text: 'AP Invoice', 
                data: { table_name: 'ap_invoices' }
            },
            { 
                text: 'Payment Voucher', 
                data: { table_name: 'payment_vouchers' }
            },
            { 
                text: 'Chart Of Accounts', 
                data: { table_name: 'chart_of_accounts' }
            },
            { 
                text: 'Misc Expenses', 
                data: { table_name: 'misc_expenses' }
            },
            { 
                text: 'Liquidated Damages', 
                data: { table_name: 'liquidated_damages' }
            },
            { 
                text: 'Navision File Config', 
                data: { table_name: 'navision_settings' }
            },
        ],
    },
    { 
        text: 'Accounts', 
        data: { table_name: null },
        children: [
            { 
                text: 'Companies', 
                data: { table_name: 'organizations' }
            },
            { 
                text: 'Users', 
                data: { table_name: 'users' },
            },
            { 
                text: 'User Duty', 
                data: { table_name: 'user_duties' },
            }
        ],
    },
    { 
        text: 'Utilities Management', 
        data: { table_name: null },
        children: [
            { 
                text: 'Meter Listing', 
                data: { table_name: 'metering_devices' }
            },
            { 
                text: 'Reading Log', 
                data: { table_name: 'meter_reading_logs' },
            }
        ],
    },
    { 
        text: 'Master Table', 
        data: { table_name: null },
        children: [
            { 
                text: 'Approval Templates', 
                data: { table_name: 'approval_templates' },
            },
            { 
                text: 'Tax and Versioning', 
                data: { table_name: 'tax' },
            },
            { 
                text: 'Tenant Sites', 
                data: { table_name: 'tenant_sites' },
            }
        ],
    },
    { 
        text: 'Budget', 
        data: { table_name: null },
        children: [
            { 
                text: 'Budget Headers', 
                data: { table_name: 'budget_headers' },
            },
            { 
                text: 'Budget Entries', 
                data: { table_name: 'budget_entries' },
            }
        ],
    },
    { 
        text: 'Tables No Soft Deletes', 
        data: { table_name: null },
        children: [
            { 
                text: 'Navision File Listing', 
                data: { table_name: 'navision_files' },
                state: { disabled: true } 
            },
            { 
                text: 'References', 
                data: { table_name: 'references' },
                state: { disabled: true } 
            },
            { 
                text: 'Vendor Linking', 
                data: { table_name: 'vendor_linkings' },
                state: { disabled: true } 
            }
        ],
    }
];

const table_name_default = 'joblist';

export default {
    name: 'Purging',
    data() {

        return {
            columnWidthSetting:{
                leftWidth:5,
                rightWidth:7
            },      
            treeData: tablePurging,
            modalDel: {
                open: false,
                loading: false
            },
            msgDelete: "Deleted successfully",
            fields: [],
            table_name: table_name_default,
            tableItems: [],
            tableConfig:{
                name: 'table-purging',
                buildFilter: true,
                controls:{
                    create:false,
                    delete: this.$checkRole(this.$accessModule.table_purging, 'delete'),
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false
                },
                filter: {},
                page: 1,
                limit: 100,
                sortColumn: "deleted_at",
                sortDirection: "desc",
            },
            columns: []
        }
    },
    components: {
        [LiquorTree.name]: LiquorTree
    },
    created() {
    },
    watch: {
        tableItems: function(val) {
            // if(val && val.length) {
            //     let item = val[0];
            //     let fields = [
            //         {
            //             key: 'actions',
            //             label: '',
            //             thStyle: "width:50px",
            //         },
            //         {
            //             key: 'id',
            //             label: 'Id',
            //             thStyle: "width:100px",
            //             sorting: true,
            //             // isFilter: true,
            //         },
            //         {
            //             key: 'deleted_at',
            //             label: 'Deleted At',
            //             thStyle: "width:200px",
            //             sorting: true,
            //             // isFilter: true,
            //         }
            //     ];
                
            //     for (const [key, value] of Object.entries(item)) {
            //         if(typeof value == 'object' || key == "deleted_at" || key == "id") continue;
            //         fields.push({
            //             key: key,
            //             label: key.replaceAll("_", " "),
            //             isActive: 1,
            //             thStyle: "width:200px; text-transform: capitalize;",
            //             sorting: true
            //         });
            //     }
            //     this.fields = fields;
            //     this.$refs.gofixTable.updateColumnSettings(fields);
            // }
        },
        columns: function(val) {
            if(val && val.length) {
                let fields = [
                    {
                        key: 'actions',
                        label: '',
                        thStyle: "width:50px",
                        filter: {
                            active: false
                        }
                    },
                    {
                        key: 'id',
                        label: 'Id',
                        thStyle: "width:100px",
                        sorting: true,
                        isFilter: true,
                        filter: {
                            active: true,
                            type: 'number'
                        }
                    },
                    {
                        key: 'deleted_at',
                        label: 'Deleted At',
                        thStyle: "width:200px",
                        sorting: true,
                        isFilter: true,
                        type: 'timestamp without time zone',
                        filter: {
                            active: true,
                            type: 'date'
                        }
                    }
                ];
                val.map(item => {
                    if(!['json', 'jsonb'].includes(item.data_type) && item.column_name != "deleted_at" && item.column_name != "id") {
                        let type = 'text';
                        if(['integer', 'bigint', 'decimal', 'numeric', 'double precision'].includes(item.data_type)) type = 'number'
                        if(['date', 'timestamp without time zone', 'timestamp with time zone', 'time without time zone', 'time with time zone'].includes(item.data_type)) type = 'date'
                        item.data_type
                        fields.push({
                            key: item.column_name,
                            label: item.column_name.replaceAll("_", " "),
                            isActive: 1,
                            thStyle: "width:200px; text-transform: capitalize;",
                            sorting: true,
                            isFilter: true,
                            type: item.data_type,
                            filter: {
                                active: true,
                                type: type
                            }
                        });
                    }
                })
                this.fields = fields;
                this.$refs.gofixTable.updateColumnSettings(fields);
                this.$refs.gofixTable.buildFilterObject(fields, []);
            }
        }
    },
    computed: {
        ...mapGetters({
        })
    },
    methods: {
        changeTableName: function(item){
            if(item.data && item.data.table_name) {
                this.columns = [];
                this.table_name = item.data.table_name;
                this.$refs.gofixTable.settings.filter = {}
                this.$refs.gofixTable.reloadTableItems();
            }
            
        },
        async getTableData(callback){
            const { tableRequest , resolve,reject } = await callback();
            tableRequest.table_name = this.table_name;
            await this.$store.dispatch("PurgingController/getItems", tableRequest)
            .then(response => {                        
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                if(!this.columns.length)this.columns = response.columns;
                resolve(response);
            })
            .catch(err => {
                this.$bvToast.toast("Can not load table", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
                reject();
            });
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.deleteEntries(ids, false, resolve, reject);
        },
        deleteAll() {
            this.deleteEntries([], true);
        },
        async deleteEntries(ids = [], is_delete_all = false, resolve = null, reject = null) {
            if(is_delete_all)
                this.modalDel.loading = true;
            await this.$store.dispatch('PurgingController/deleteItems', {
                ids: ids,
                is_delete_all: is_delete_all,
                table_name: this.table_name,
            })
            .then(response => {
                this.modalDel.open = false;
                this.modalDel.loading = false;
                if(is_delete_all) {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    return this.$bvToast.toast( this.msgDelete, {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    }) 
                }
                if(resolve) {
                    resolve(this.msgDelete);
                }
                
            })
            .catch(err => {
                console.log(err)
                this.modalDel.loading = false;
                if(reject) {
                    reject();
                }
            });
        }
    },
}
</script>

